export const environment = {
  production: true,
  BASE_URL: 'https://iplanner-services-dev.leonisa.com',
  BASE_URL2: 'https://iplanner-services-dev.leonisa.com',
  BASE_URL_ETL: 'https://iplanner-services-dev.leonisa.com',
  SITE_KEY: '6LfG_HYaAAAAAEO4tHpCjc7jbTLZZYsN-bI1vuyA',
  TOKEN_KEY: 'access_token',
  USER_KEY: 'auth-user',
};
